module.exports = __webpack_public_path__ + "img/adv_search_monsters.d2fd2435.svg";